export const LABEL = 'Lock access';
export const MESSAGE = 'Enabling this option would mean that this quiz is no longer accessible and will accept any response.';
